var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ '--width': _vm.width, '--height': _vm.height, transformOrigin: '0 0', transform:("scale(" + _vm.widthFactor + "," + _vm.heightFactor + ")")}),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }